import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import { Visibility, Download } from "@mui/icons-material";
import PdfViewer from "../../component/PDFViewer.component";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import { ThemeColor } from "../../component/theme/color";

const UniversityProccessListSection = ({
  row,
  columns,
  loading,
  type,
  getRowClassName,
}) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  console.log(row);

  const handleViewPdf = (url) => {
    setPdfUrl(url);
    setOpenDialog(true);
  };

  const handleDownloadPdf = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "document.pdf"; // Customize the filename here
    link.click();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setPdfUrl(null);
  };

  const updatedColumns = [
    ...columns,
    ...(type !== "program"
      ? [
          {
            field: "actions",
            headerName: "Actions",
            width: 650,
            renderCell: (params) => {
              const fileType = params.row.type;
              const isPdf = fileType === "application/pdf"; // adjust condition if needed
              return (
                <>
                  {isPdf && (
                    <IconButton onClick={() => handleViewPdf(params.row.url)}>
                      <Visibility />
                    </IconButton>
                  )}
                  <IconButton onClick={() => handleDownloadPdf(params.row.url)}>
                    <Download />
                  </IconButton>
                </>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <>
      {row?.length > 0 ? (
        <div style={{ height: 500, width: "100%", border: "none",overflow:"scroll"}}>
          <DataGrid
            rows={row}
            columns={updatedColumns}
            loading={loading}
            getRowClassName={getRowClassName}
            disableRowSelectionOnClick
            // hideFooter
            style={{
              border: "none", // Remove outer table border
            }}
            sx={{
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ddd", // Row borders
              },
              "& .MuiDataGrid-columnHeader": {
                fontWeight: fontWeight.W600, // Bold column headers
                backgroundColor: ThemeColor.NAVYBLUE,
                color: "white", // Light background for headers
              },
              "& .MuiDataGrid-row": {
                transition: "background-color 0.3s", // Smooth background color transition
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f0f0f0", // Row hover effect
              },
            }}
          />
        </div>
      ) : (
        <Typography color={ThemeColor.GREY}>Nothing to Display</Typography>
      )}

      {/* PDF Viewer Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md">
        <DialogTitle>
          <Typography
            align="center"
            fontSize={fontSize.h3.large}
            fontWeight={fontWeight.W700}
          >
            View Document
          </Typography>
        </DialogTitle>
        <DialogContent>
          {pdfUrl && <PdfViewer fileUrl={pdfUrl} onClose={handleCloseDialog} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UniversityProccessListSection;
